import React from 'react'

const TableHead = props => {
  return <thead>{props.children}</thead>
}

export default TableHead
